import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgDocumentFilled24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12 8.10457 12.8954 9 14 9H21V21C21 22.6569 19.6569 24 18 24H6C4.34315 24 3 22.6569 3 21V3C3 1.34315 4.34315 7.2479e-08 6 0H12V7ZM21 7.5H14.5C13.9477 7.5 13.5 7.05228 13.5 6.5V0L21 7.5Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentFilled24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=DocumentFilled24.svg.js.map
